import { Loader2 } from "lucide-react";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { authClient } from "@/lib/auth-client";
import { AppSidebar } from "./app-sidebar";
import { SiteHeader } from "./site-header";
import { TourProvider } from "./tour";
import { SidebarInset, SidebarProvider } from "./ui/sidebar";

export const MainLayout = () => {
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const { data: memberRole, isPending: rolePending } = authClient.useActiveMemberRole();

  useEffect(() => {
    if (!rolePending && memberRole?.role === "rider") {
      navigate("/rider", { replace: true });
    }
  }, [memberRole, rolePending, navigate]);

  if (rolePending || memberRole?.role === "rider") {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  const handleTourComplete = () => {
    if (pathname === "/dashboard") {
      localStorage.setItem("home_tour_completed", "true");
    }
    if (pathname === "/settings") {
      localStorage.setItem("settings_tour_completed", "true");
    }
  };
  return (
    <TourProvider onComplete={handleTourComplete}>
      <SidebarProvider
        style={
          {
            "--sidebar-width": "calc(var(--spacing) * 72)",
            "--header-height": "calc(var(--spacing) * 12)",
          } as React.CSSProperties
        }
      >
        <AppSidebar variant="inset" />
        <SidebarInset>
          <SiteHeader />
          <div className="flex flex-1 flex-col">
            <div className="@container/main flex flex-1 flex-col gap-2">
              <Outlet />
            </div>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </TourProvider>
  );
};
